import { Input, Select, Icon } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddressSelectGroup from "../../../../../components/AddressSelectGroup/AddressSelectGroup";
import { declOfNum } from "../../../../../helpers/dspx-utils";
import getFlats from "../../../requests/getFlats";
import getHouses from "../../../requests/getHouses";
import getStreets from "../../../requests/getStreets";
import { filterSettings } from "../../../store/actions/actions";
import getAddresses from "../../../store/thunks/getAddresses";
import getDebtsList from "../../../store/thunks/getDebtsList";
const { Option } = Select;

const periodOptions = () => {
	const options = [];
	for (let monthCount = 1; monthCount < 13; monthCount++) {
		options.push(
			<Option key={monthCount} value={monthCount}>
				{monthCount} {declOfNum(monthCount, ["месяц", "месяца", "месяцев"])}
			</Option>
		);
	}

	return options;
};

const Filter = ({ fileId }) => {
	const mounted = useRef(false);
	useEffect(() => {
		mounted.current = true;
		return () => (mounted.current = false);
	}, []);

	const [streets, setStreets] = useState([]);
	const [houses, setHouses] = useState([]);
	const [flats, setFlats] = useState([]);

	const [streetsLoading, setStreetsLoading] = useState(false);
	const [housesLoading, setHousesLoading] = useState(false);
	const [flatsLoading, setFlatsLoading] = useState(false);

	const dispatch = useDispatch();
	const flatId = useSelector((store) => store.debtsStore.filter?.flatId);
	const houseId = useSelector((store) => store.debtsStore.filter?.houseId);
	const streetId = useSelector((store) => store.debtsStore.filter?.streetId);
	const account = useSelector((store) => store.debtsStore.filter?.account);
	const phone = useSelector((store) => store.debtsStore.filter?.phone);
	const debt = useSelector((store) => store.debtsStore.filter?.debt);
	const months = useSelector((store) => store.debtsStore.filter?.months);
	
	useEffect(() => {
		(async () => {
			setStreetsLoading(true);
			const data = await getStreets(fileId);
			if (!mounted.current) {
				return;
			}
			setStreets(data);
			setStreetsLoading(false);
		})();
	}, [fileId]);

	const onStreetSelected = useCallback(
		async (streetId) => {
			setHousesLoading(true);
			dispatch(filterSettings({ streetId }));
			const data = await getHouses(streetId, fileId);
			if (!mounted.current) {
				return;
			}
			setHouses(data);
			setHousesLoading(false);
		},
		[fileId]
	);

	const onHouseSelected = useCallback(
		async (houseId) => {
			setFlatsLoading(true);
			dispatch(filterSettings({ houseId: houseId }));
			const data = await getFlats(houseId, fileId);
			if (!mounted.current) {
				return;
			}
			setFlats(data);
			setFlatsLoading(false);
		},
		[fileId]
	);

	const onFlatChange = useCallback(async (flatId) => {
		dispatch(filterSettings({ flatId }));
	}, []);

	return (
		<div className="filter-row">
			<div className="filter-part-row">
				<div className="address_filter">
					<AddressSelectGroup
						streets={streets}
						flats={flats}
						houses={houses}
						showSearch
						street={streetId}
						house={houseId}
						flat={flatId}
						streetsLoading={streetsLoading}
						housesLoading={housesLoading}
						flatsLoading={flatsLoading}
						handleStreetChange={onStreetSelected}
						handleHouseChange={onHouseSelected}
						handleFlatChange={onFlatChange}
					/>
				</div>
				<Input
					allowClear
					className="file_view-header-filter-item"
					style={{ width: "250px" }}
					addonBefore={
						<Icon type="credit-card" style={{ fontSize: 19, color: "#888f" }} />
					}
					showArrow={false}
					placeholder="Номер л.с."
					value={account}
					onChange={(e) =>
						dispatch(filterSettings({ account: e.target.value }))
					}
				></Input>
			</div>
			<div className="filter-part-row">
				<Input
					allowClear
					className="file_view-header-filter-item"
					style={{ width: "190px" }}
					addonBefore={
						<Icon type="phone" style={{ fontSize: 19, color: "#888f" }} />
					}
					value={phone}
					showArrow={false}
					placeholder="Телефон"
					onChange={(e) => dispatch(filterSettings({ phone: e.target.value }))}
				/>
				<Input
					allowClear
					className="file_view-header-filter-item"
					style={{ width: "240px" }}
					addonBefore={
						<span
							style={{
								color: "#888888",
								fontWeight: "bold",
								fontSize: "14px",
								lineHeight: "21px",
							}}
						>
							От
						</span>
					}
					addonAfter={
						<span
							style={{
								color: "#888888",
								fontWeight: "bold",
								fontSize: "14px",
								lineHeight: "21px",
							}}
						>
							руб.
						</span>
					}
					showArrow={false}
					placeholder="Сумма долга"
					value={debt}
					onChange={(e) => dispatch(filterSettings({ debt: e.target.value }))}
				/>
				<Select
					allowClear
					value={months}
					placeholder="Период задолженности"
					style={{ width: "210px" }}
					onChange={(value) => {
						dispatch(filterSettings({ months: value }));
					}}
				>
					{periodOptions()}
				</Select>
			</div>
		</div>
	);
};

export default Filter;
